module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "uploadVideo",
    staticClass: "rt-upload-video",
    class: 'upload-video-' + _vm.listType
  }, [_vm._l((_vm.videoList), function(item, i) {
    return _c('div', {
      key: i,
      ref: "item",
      refInFor: true,
      staticClass: "file-item",
      style: ({
        width: _vm.videoWidth
      })
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "scale"
    }, [_c('div', {
      staticClass: "video",
      on: {
        "click": function($event) {
          return _vm.videoClick(item.url)
        }
      }
    }, [(!item.url) ? _c('div', {
      staticClass: "uploading"
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/imgs/file_icon.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "uploading-text"
    }, [(_vm.videoFlag == true && item.videoUploadPercent > 0) ? _c('span', [_vm._v(_vm._s(_vm.$tx('正在上传...', 'xpc.uploadfile.uploading')))]) : (item.videoUploadPercent == 100 && !item.name) ? _c('span', [_vm._v(_vm._s(_vm.$tx('上传错误', 'xpc.uploadfile.uploadError')))]) : _vm._e()])]) : _c('div', [_c('video', {
      attrs: {
        "src": item.url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "layout"
    }, [_c('rt-icon', {
      attrs: {
        "name": "rt-base-angle_right_circle",
        "size": "35",
        "color": "#fff"
      }
    })], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "detail"
    }, [_c('div', {
      staticClass: "detail-name"
    }, [_c('rt-icon', {
      attrs: {
        "color": _vm.SCSS_VARIABLES.COLOR_SUCCESS,
        "name": "rt-base-file-video-fill",
        "size": "21"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "name"
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])], 1), _vm._v(" "), (_vm.videoFlag == true && item.videoUploadPercent > 0) ? _c('el-progress', {
      staticStyle: {
        "margin-top": "7px"
      },
      attrs: {
        "percentage": item.videoUploadPercent,
        "show-text": false
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "progress-operation",
      class: {
        paddingTop: _vm.videoFlag == true && item.videoUploadPercent > 0
      }
    }, [(_vm.videoFlag == true && item.videoUploadPercent > 0) ? _c('p', {
      staticClass: "progress"
    }, [_vm._v("\n            " + _vm._s(_vm.$tx(("已上传" + (item.videoUploadPercent) + "%"), 'xpc.uploadfile.uploadPercent', {
      count: item.videoUploadPercent
    })) + "\n          ")]) : (item.videoUploadPercent == 100 && !item.name) ? _c('p', {
      staticClass: "progress"
    }, [_c('rt-icon', {
      attrs: {
        "color": _vm.SCSS_VARIABLES.COLOR_DANGER,
        "name": "rt-base-close_line",
        "size": "14"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$tx('上传错误', 'xpc.uploadfile.uploadError')))]), _vm._v(" "), _c('rt-icon', {
      attrs: {
        "color": _vm.SCSS_VARIABLES.NEUTRAL_COLOR_SECONDARY,
        "name": "rt-base-wrong-circle",
        "size": "14"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "btn"
    }, [_c('rt-button', {
      attrs: {
        "text": "",
        "type": "plain"
      },
      on: {
        "click": function($event) {
          return _vm.reUpload(i)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$tx('重新上传', 'xpc.uploadfile.reUpload')) + "\n            ")]), _vm._v(" "), _c('rt-popconfirm', {
      attrs: {
        "title": _vm.$tx('确定需要删除这条内容吗？', 'xpc.uploadfile.confirmdelete')
      },
      on: {
        "onConfirm": function($event) {
          return _vm.onConfirm(item.name, i)
        }
      }
    }, [_c('rt-button', {
      attrs: {
        "slot": "reference",
        "text": "",
        "type": "plain"
      },
      slot: "reference"
    }, [_vm._v("\n                " + _vm._s(_vm.$tx('删除', 'xpc.uploadfile.delete')) + "\n              ")])], 1)], 1)])], 1)])])
  }), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    staticClass: "avatar-uploader",
    style: (_vm.computedHeight),
    attrs: {
      "show-file-list": false,
      "limit": _vm.limit,
      "multiple": _vm.multiple,
      "on-success": _vm.handleVideoSuccess,
      "before-upload": _vm.beforeUploadVideo,
      "http-request": _vm.uploadFile,
      "file-list": _vm.fileList,
      "list-type": _vm.listType,
      "action": ""
    }
  }, [_c('div', {
    staticClass: "avator-uploader-main"
  }, [_c('rt-icon', {
    staticClass: "avatar-uploader-icon",
    attrs: {
      "name": "rt-base-plus",
      "size": "50"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "avatar-uploader-word"
  }, [_vm._v("\n        " + _vm._s(_vm.$tx('请将需要上传的文件添加到此处', 'xpc.uploadfile.pleaseAddFileHint')) + "\n      ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.videoVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.videoVisible = $event
      }
    }
  }, [_c('video', {
    attrs: {
      "src": _vm.previewUrl,
      "controls": "controls"
    }
  })])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e86e0df6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/uploadVideo/rtUploadVideo.vue
// module id = 2170
// module chunks = 228